<input kendoTextBox #search
       type="text" placeholder=""
       [value]="inputFieldValue"
       [disabled]="disabled"
       [readonly]="readonly"
       (blur)="onTouched()"
       [attr.maxLength]="maxLength ? maxLength : null"
       (input)="inputChanged($event)"
       [formControl]="ngControlFormControl || dummyFc">

